export default "__VITE_ASSET__4PVctQG2__"